import '.am{height:100%;}.ssr-plugin'
import React, { ReactNode, useState } from 'react'
import {
  Button,
  Modal,
  BasedFinder,
  Stack,
  IconButton,
} from '../../../index.js'
import { styled } from 'inlines'
import { colors } from '../../../index.js'

export const SelectUploadedFileModal = ({
  children,
  setFile,
}: {
  children?: ReactNode
  setFile?: (file: { src?: string }) => void
}) => {
  const [selected, setSelected] = useState<Set<number>>()
  const [fileSrc, setFileSrc] = useState('')

  return (
    <Modal size="large" title={`Add a file`}>
      <Modal.Trigger>{children}</Modal.Trigger>
      <Modal.Content>
        <Modal.Body>
          <div className="am"
          >
            <BasedFinder
              schemaType="file"
              selectedRows={selected}
              onSelectedRowsChange={setSelected}
              onRowSelect={(_index, values) => setFileSrc(values?.src)}
              variant="modal"
            >
              <BasedFinder.Header icon="page" />
              <BasedFinder.Body />
            </BasedFinder>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Stack justify="end" gap={16}>
            <Button variant="border" onClick={() => Modal.Close()}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                setFile({ src: fileSrc })
                Modal.Close()
              }}
              disabled={selected?.size !== 1}
            >
              Add file
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
